import styled from 'styled-components';

export const AlternateRoutes = styled.div(
    props => `
    padding: 24px 40px;
    border-radius: 8px;
    background-color: #ffffff;
    margin-top: 16px;
    .altrntRoutesHeading {
        color: ${props.theme ? props.theme.colors.downriver.base : '#141823'};
        font-family: ${props.theme && props.theme.font.fontFamily};
        font-size: ${props.theme && props.theme.font.custom(28)};
        font-weight: bold;
        margin-bottom: 2px;
    }
    > p:not(.altrntRoutesHeading) {
        font-family: 'roboto';
        font-size: 1.6rem;
        line-height: 1.38;
        color: ${props.theme ? props.theme.colors.downriver.base : '#141823'};
    }
    ul {
        margin-top: 16px;
    }
    ul li {
        display: flex;
        align-items: center;
        padding: 16px 0;
        border-bottom: solid 1px #f5f5f5;
        &:last-child {
            border-bottom: 0 none;
        }
    }
    .arrow {
        border: solid black;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 3px;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        border-color: #2276e3;
    }
    a {
        width: 100px;
        font-family: Quicksand;
        font-size: 1.6rem;
        font-weight: bold;
        line-height: 1.38;
        color: #2274e0;
        text-transform: uppercase;
    }
    .seperator {
        width: 10px;
        height: 1px;
        background-color: #000000;
        margin: 0 8px;
    }
    p {
        display: flex;
        align-items: center;
        font-family: 'roboto';
        font-size: 1.6rem;
        line-height: 1.2;
        color: ${ props.theme ? props.theme.colors.downriver.medium : '#777'};
        margin-bottom: 4px;
    }
    p.title {
        font-family: Quicksand;
        font-size: 2rem;
        font-weight: bold;
        color: ${props.theme ? props.theme.colors.downriver.base : '#141823'};
        margin-bottom: 8px;
    }
` 
);
